/*
String formating mixins.
------------------------------------------------------------------------ */
import pluralize from 'pluralize'

export default {

  methods: {

    webSafeFileName (str) {
      return str.replace(/[\\~#%&*{}/:<>?|"-]/g, '\\$&')
    },


    removeSpecialChars (str) {
      return str.replace(/[^a-zA-Z ]/g, ' ')
    },



    titleCase (str, rem = null) {
      if (rem) {
        str = str.replace(rem, ' ')
      }

      return str.replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        }
      )
    },


    allCaps (value) {
      return value.toUpperCase()
    },


    camelize (str) {
      return str.replace(/([A-Z])/g, (match) => ` ${match}`).replace(/^./, (match) => match.toUpperCase())
    },


    ellipsis (str, num = 24) {

      if (!str) {
        return null
      }

      if (str && str.length > num) {
        return str.substring(0, num) + '...'
      }

      return str
    },


    // This a more exact version than the basic one in main.js
    pluralise (str, qty = 0) {
      return pluralize(str, qty)
    }

  }

}



// WEBPACK FOOTER //
// ./src/mixins/FormattingMixins.js